import { createDefaultFormatters, createStandardConfig } from './utils'

/**
 * Australia Address Configuration
 */
export const AU_CONFIG = createStandardConfig({
  countryCode: 'AU',
  countryName: 'Australia',
  requiresStreetNumber: true,
  formatters: createDefaultFormatters({ address2Style: 'forwardSlash' }),
  fieldOverrides: {
    address2: {
      labelKey: 'address-config.unit-flat'
    },
    city: {
      labelKey: 'address-config.suburb-town',
      errorKey: 'address-config.suburb-town-required'
    },
    postalCode: {
      labelKey: 'address-config.postcode',
      errorKey: 'address-config.postcode-required'
    }
  }
})
